import {ShoppingCartHelper} from "../helpers/shopping_cart/shopping_cart_helper.js";
import {AddProductToOrderlistModal} from "../helpers/orderlists/add_product_to_orderlist_modal.js";
import {DeleteOrderlistModal} from "../orderlists/delete_modal.js";
import {OrderlistsHelper} from "../helpers/orderlists/orderlists_helper.js";

class productDetailPage {

    constructor() {

        $('#back-to-search-index-btn').click((event) => {

            event.preventDefault();
            if(document.referrer.indexOf('/products') !== -1) {
                window.history.back();
            } else {
                window.location = '/products';
            }
        });

        $('#add-product-to-orderlist-btn').click(() => {
            AddProductToOrderlistModal.showModal(parseInt($('#add-product-to-orderlist-btn').attr('data-product-id')));
        });

        this.relatedProductsSection = $("#related-products-section");

        this._initGallery();
        this._checkAttachmentUrls();

        if($('#manage-product-modal').length > 0) {

            this.manageProductImageModal = $('#manage-product-modal');
            this.emptyImageAlert = $('#manage-product-image-error');
            this.dropzone = new Dropzone('#product-image-dropzone', {
                url: 'test',
                addRemoveLinks: true,
                autoQueue: false,
                autoProcessQueue: false,
                maxFiles: 1,
                createImageThumbnails: true,
                thumbnailWidth: null,
                thumbnailHeight: null,
                dictRemoveFile: "Wijzig afbeelding",
                acceptedFiles: 'image/*'
            });

            this.editProductImageModalBtn = $('#edit-product-modal-btn');
            this.editProductImageModalBtn.click(() => {
                this.editProductImage();
            });

            this.saveDescriptionBtn = $('#save-detail-description-btn');
            this.saveDescriptionBtn.click(() => {
                this.editProductDescription();
            });
        }
    }

    async _initGallery() {
        const mainSwiperEl  = document.getElementById('gallery-swiper');
        const thumbSwiperEl = document.getElementById('gallery-thumbnail-swiper');
        if (!mainSwiperEl) return;

        const mainSlides  = Array.from(mainSwiperEl.querySelectorAll('.gallery-item'));
        const thumbSlides = thumbSwiperEl ? Array.from(thumbSwiperEl.querySelectorAll('.swiper-slide')) : [];

        // Check all slide image URLs in parallel; skip video items (no <img> to check).
        // Use the <a href> attribute (not img.src) because onerror may have already
        // replaced img.src with the fallback placeholder before this code runs.
        const results = await Promise.all(mainSlides.map((slide, idx) => new Promise(resolve => {
            const img = slide.querySelector('img');
            if (!img) return resolve({ idx, ok: true });
            const url = slide.getAttribute('href') || img.getAttribute('src') || '';
            if (!url || url.startsWith('/img/default/')) return resolve({ idx, ok: false });
            const testImg = new Image();
            testImg.onload  = () => resolve({ idx, ok: true });
            testImg.onerror = () => resolve({ idx, ok: false });
            testImg.src     = url;
        })));

        // Remove broken slides in reverse index order to preserve remaining indices
        results
            .filter(r => !r.ok)
            .map(r => r.idx)
            .sort((a, b) => b - a)
            .forEach(idx => {
                if (mainSlides[idx])  mainSlides[idx].remove();
                if (thumbSlides[idx]) thumbSlides[idx].remove();
            });

        // Destroy the theme-initialized lightGallery instance and reinit without broken items
        const galleryEl = mainSwiperEl.closest('.gallery');
        if (galleryEl) {
            const lgUid = parseInt(galleryEl.getAttribute('data-lg-uid'), 10);
            if (!isNaN(lgUid) && window.lgData && window.lgData[lgUid]) {
                window.lgData[lgUid].destroy();
            }

            lightGallery(galleryEl, {
                selector:            '.gallery-item',
                plugins:             [lgZoom, lgFullscreen, lgVideo],
                licenseKey:          'D4194FDD-48924833-A54AECA3-D6F8E646',
                download:            false,
                autoplayVideoOnSlide: true,
                zoomFromOrigin:      false,
                youtubePlayerParams: { modestbranding: 1, showinfo: 0, rel: 0 },
                vimeoPlayerParams:   { byline: 0, portrait: 0, color: '6366f1' },
            });
        }

        // Init Swiper only when slides remain
        if (!mainSwiperEl.querySelector('.gallery-item')) return;

        // Hide thumbnail strip (and the <hr> before it) when only 1 slide is left after cleanup
        const remainingSlides = mainSwiperEl.querySelectorAll('.gallery-item').length;
        if (remainingSlides <= 1 && thumbSwiperEl) {
            const hr = thumbSwiperEl.previousElementSibling;
            if (hr && hr.tagName === 'HR') hr.remove();
            thumbSwiperEl.remove();
        }

        let thumbSwiper = null;
        if (thumbSwiperEl && remainingSlides > 1) {
            thumbSwiper = new Swiper("#gallery-thumbnail-swiper", {
                slidesPerView: 2,
                freeMode: true,
                watchSlidesProgress: true,
                watchOverflow: true,
                navigation: {
                    nextEl: "#gallery-thumbnail-next",
                    prevEl: "#gallery-thumbnail-prev",
                },
                breakpoints: {
                    768: {
                        slidesPerView: 3
                    }
                }
            });
        }
        new Swiper("#gallery-swiper", {
            loop: true,
            navigation: {
                nextEl: "#gallery-main-next",
                prevEl: "#gallery-main-prev",
            },
            ...(thumbSwiper ? { thumbs: { swiper: thumbSwiper } } : {}),
        });
    }

    _checkAttachmentUrls() {
        const rows = Array.from(document.querySelectorAll('.attachment-row[data-attachment-url]'));
        if (!rows.length) return;

        // Hide all rows immediately and show loader to prevent flicker
        rows.forEach(row => row.style.display = 'none');
        document.getElementById('attachments-loader')?.classList.remove('d-none');

        const urls = [...new Set(rows.map(r => r.getAttribute('data-attachment-url')))];

        $.post('/products/checkUrls', { urls })
            .then(results => {
                rows.forEach(row => {
                    const url = row.getAttribute('data-attachment-url');
                    if (results[url] === false) {
                        row.remove();
                    } else {
                        row.style.display = '';
                    }
                });

                // If the main attachments table is now empty, swap to empty state
                const tableWrapper = document.getElementById('attachments-table-wrapper');
                if (tableWrapper) {
                    const remainingRows = tableWrapper.querySelectorAll('.attachment-row').length;
                    if (remainingRows === 0) {
                        const showMoreBtn = document.querySelector('#attachments-card [data-bs-target="#attachments-modal"]');
                        tableWrapper.remove();
                        if (showMoreBtn) showMoreBtn.remove();
                        document.getElementById('attachments-empty-state')?.classList.remove('d-none');
                    }
                }

                // Update "Toon alle N documenten" button count
                const remaining = document.querySelectorAll('#attachments-modal .attachment-row').length;
                const showAllBtn = document.querySelector('[data-bs-target="#attachments-modal"]');
                if (showAllBtn && remaining <= 10) {
                    showAllBtn.remove();
                } else if (showAllBtn) {
                    showAllBtn.textContent = '';
                    showAllBtn.innerHTML = `Toon alle ${remaining} documenten <i class="ai-arrow-right ms-1"></i>`;
                }
            })
            .catch(() => {})
            .always(() => {
                document.getElementById('attachments-loader')?.classList.add('d-none');
            });
    }

    editProductDescription() {

        const description = $('#detail-description-textarea').val();
        const productId = this.relatedProductsSection.attr('data-product-id');

        this.saveDescriptionBtn.addClass('loading disabled');
        $.post('/products/editDescription', {
            product_id: productId,
            description: description
        })
            .then(() => {
                window.location.reload();
            })
            .catch(() => {
                // TODO
            })
            .always(() => {
                this.saveDescriptionBtn.removeClass('loading disabled');
            });
    }

    editProductImage() {

        const selectedImages = this.dropzone.getAcceptedFiles();

        if(selectedImages.length === 0) {
            this.emptyImageAlert.removeClass('hidden');
        } else {
            this.emptyImageAlert.addClass('hidden');

            const postData = new FormData();
            postData.append('image', selectedImages[0]);
            postData.append('product_id', $('#related-products-section').attr('data-product-id'));

            this.editProductImageModalBtn.addClass('loading disabled');
            $.ajax({
                url: '/Products/editImage',
                data: postData,
                processData: false,
                contentType: false,
                type: 'POST'
            })
                .then((response) => {

                    this.dropzone.removeAllFiles();
                    this.manageProductImageModal.modal('hide');
                    window.location.reload();
                })
                .catch((error) => {

                    // TODO
                })
                .always(() => {
                    this.editProductImageModalBtn.removeClass('loading disabled');
                });
        }
    }
}

export let ProductDetailPage = new productDetailPage();
